(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _App = require("./modules/App");

var _ContactForm = _interopRequireDefault(require("./modules/ContactForm"));

var _Cookiebot = require("./modules/Cookiebot");

require("lazysizes");

require("lazysizes/plugins/bgset/ls.bgset.min.js");

require("lazysizes/plugins/unveilhooks/ls.unveilhooks.min.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// import { cookieMngt } from "./modules/CookieMngt";
(0, _App.app)();

if (document.querySelector("#registration-form")) {
  new _ContactForm["default"]();
}

(0, _Cookiebot.cookiebotGmap)();

},{"./modules/App":2,"./modules/ContactForm":4,"./modules/Cookiebot":5,"lazysizes":7,"lazysizes/plugins/bgset/ls.bgset.min.js":8,"lazysizes/plugins/unveilhooks/ls.unveilhooks.min.js":9}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.app = app;

function app() {
  $(document).ready(function () {
    // Show Back to Top Button
    var $window = $(window),
        $document = $(document),
        button = $('.scroll-icon-up');
    $window.scroll(function () {
      if ($window.scrollTop() > 200) {
        button.css('visibility', 'visible'), button.stop(true).animate({
          opacity: 1
        }, 10);
      } else {
        button.stop(true).animate({
          opacity: 0
        }, 10);
      }
    });
    button.on('click', function (e) {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: 0
      }, '300');
    }); // Init textarea

    if ($('textarea').length > 0) {
      $('textarea').val('');
      M.textareaAutoResize($('textarea'));
      $('textarea#message').characterCounter();
    } // Init Form Select


    $('select').formSelect(); // Init Sidenav

    $(".sidenav").sidenav();
    $('.scrollspy').scrollSpy({
      scrollOffset: 0
    }); // Init Parallax

    $(".parallax").parallax(); // Init Slider

    $(".slider").slider({
      height: "inherit",
      indicators: true,
      transition: 1500,
      duration: 500,
      interval: 6000
    }); // Init Tabs

    $(".tabs").tabs({
      duration: 300
    }); //Init Collabable

    $(".collapsible").collapsible(); //Init OWL Carousel 

    if ($(".dassindwir-carousel").length > 0) {
      $(".dassindwir-carousel").owlCarousel({
        loop: false,
        responsiveClass: true,
        margin: 15,
        autoHeight: true,
        stagePadding: 0,
        nav: true,
        navText: ['<span class="btn-flat prev waves-effect"><span class="material-icons icon-sprite span-elm icon--keyboard_arrow_left"></span></span>', '<span class="btn-flat next waves-effect"><span class="material-icons icon-sprite span-elm icon--keyboard_arrow_right"></span></span>'],
        navContainer: '.dassindwir-carousel .custom-nav',
        responsive: {
          0: {
            items: 1
          },
          600: {
            items: 1
          },
          1000: {
            items: 1
          }
        }
      });
    }

    if ($(".testimonial-carousel").length > 0) {
      $(".testimonial-carousel").owlCarousel({
        loop: true,
        responsiveClass: true,
        margin: 15,
        autoHeight: true,
        stagePadding: 0,
        autoplay: false,
        autoplayTimeout: 5000,
        autoplayHoverPause: true,
        nav: true,
        navText: ['<span class="btn-flat prev wide waves-effect"><span class="material-icons icon-sprite span-elm icon--keyboard_arrow_left"></span></span>', '<span class="btn-flat next wide waves-effect"><span class="material-icons icon-sprite span-elm icon--keyboard_arrow_right"></span></span>'],
        navContainer: '.testimonial-carousel .custom-nav',
        responsive: {
          0: {
            items: 1
          },
          600: {
            items: 1
          },
          1000: {
            items: 1
          }
        }
      });
    }

    if ($(".leistungsversprechen-carousel").length > 0) {
      $(".leistungsversprechen-carousel").owlCarousel({
        margin: 15,
        responsiveClass: true,
        stagePadding: 0,
        responsive: {
          0: {
            items: 1
          },
          600: {
            items: 2
          },
          1201: {
            items: 3
          }
        }
      });
    }
  });
}

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.databaseConenct = databaseConenct;

function databaseConenct() {
  var firebaseConfig = {
    apiKey: "AIzaSyAll4yeY3mPxabEajNJ2UV9uDXOIS9FJhk",
    authDomain: "ppw-contactform.firebaseapp.com",
    databaseURL: "https://ppw-contactform.firebaseio.com",
    projectId: "ppw-contactform",
    storageBucket: "ppw-contactform.appspot.com",
    messagingSenderId: "433699681149",
    appId: "1:433699681149:web:6f3adac03a5559b3"
  };
  firebase.initializeApp(firebaseConfig); // Get a reference to the database service

  var database = firebase.database(); // Reference messages collection

  var messagesRef = database.ref("messages"); // Get values

  var firstname = getInputVal("first-name");
  var lastname = getInputVal("last-name");
  var email = getInputVal("email");
  var phone = getInputVal("phone");
  var subject = getInputVal("subject");
  var message = getInputVal("message");
  var dsgvo = getInputVal("checkboxconsens");
  saveMessage(firstname, lastname, email, phone, subject, message, dsgvo); // Function to get get form values

  function getInputVal(id) {
    return document.getElementById(id).value;
  } // Save message to firebase


  function saveMessage(firstname, lastname, email, phone, subject, message, dsgvo) {
    var newMessageRef = messagesRef.push();
    newMessageRef.set({
      firstName: firstname,
      lastName: lastname,
      email: email,
      phone: phone,
      subject: subject,
      message: message,
      dsgvo: dsgvo
    });
  }
}

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ConfigDatabase = require("./ConfigDatabase");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ContactForm =
/*#__PURE__*/
function () {
  function ContactForm() {
    _classCallCheck(this, ContactForm);

    this.form = document.querySelector("#registration-form");
    this.allFields = document.querySelectorAll("#registration-form .form-control");
    this.insertValidationElements();
    this.firstName = document.querySelector("#first-name");
    this.firstName.previousValue = "";
    this.lastName = document.querySelector("#last-name");
    this.lastName.previousValue = "";
    this.email = document.querySelector("#email");
    this.email.previousValue = "";
    this.phone = document.querySelector("#phone");
    this.subject = document.querySelector("#subject");
    this.subject.previousValue = "";
    this.helperText = document.querySelector(".helper-text");
    this.textArea = document.querySelector(".materialize-textarea");
    this.textArea.previousValue = "";
    this.progressbar = document.getElementById("progressbar");
    this.btnKontaktform = document.getElementById("btn-kontaktform");
    this.message = document.querySelector("#message");
    this.honeypot = document.getElementById("city");
    this.checkboxconsens = document.getElementById("checkboxconsens");
    this.events();
  }

  _createClass(ContactForm, [{
    key: "events",
    value: function events() {
      var _this = this;

      this.form.addEventListener("submit", function (e) {
        e.preventDefault();

        _this.formSubmitHandler();
      });
      this.firstName.addEventListener("keyup", function () {
        _this.isDifferent(_this.firstName, _this.firstNameHandler);
      });
      this.lastName.addEventListener("keyup", function () {
        _this.isDifferent(_this.lastName, _this.lastNameHandler);
      });
      this.email.addEventListener("keyup", function () {
        _this.isDifferent(_this.email, _this.emailHandler);
      });
      this.phone.addEventListener("keyup", function () {
        _this.isDifferent(_this.phone, _this.phoneHandler);
      });
      this.textArea.addEventListener("keyup", function () {
        _this.isDifferent(_this.textArea, _this.textAreaHandler);
      });
      this.firstName.addEventListener("blur", function () {
        _this.isDifferent(_this.firstName, _this.firstNameHandler);
      });
      this.lastName.addEventListener("blur", function () {
        _this.isDifferent(_this.lastName, _this.lastNameHandler);
      });
      this.email.addEventListener("blur", function () {
        _this.isDifferent(_this.email, _this.emailHandler);
      });
      this.phone.addEventListener("blur", function () {
        _this.isDifferent(_this.phone, _this.phoneHandler);
      });
      this.textArea.addEventListener("blur", function () {
        _this.isDifferent(_this.textArea, _this.textAreaHandler);
      });
      this.subject.addEventListener("change", function () {
        _this.isDifferent(_this.subject, _this.subjectHandler);
      });
      this.checkboxconsens.addEventListener("change", function () {
        if (_this.checkboxconsens.checked == true) {
          _this.btnKontaktform.classList.add('pulse');
        } else {
          _this.btnKontaktform.classList.remove('pulse');
        }
      });
    }
  }, {
    key: "formSubmitHandler",
    value: function formSubmitHandler() {
      var _this2 = this;

      this.firstNameImmediately();
      this.firstNameAfterDelay();
      this.lastNameImmediately();
      this.lastNameAfterDelay();
      this.phoneImmediately();
      this.phoneAfterDelay();
      this.emailAfterDelay();
      this.textAreaImmediately();
      this.textAreaAfterDelay();
      this.subjectAfterDelay();
      this.checkConsens();
      this.honeypotValue();

      if (!this.firstName.errors && !this.lastName.errors && !this.phone.errors && !this.email.errors && !this.textArea.errors && !this.subject.errors && !this.checkboxconsens.errors && !this.honeypot.errors) {
        (0, _ConfigDatabase.databaseConenct)();
        this.hideSubmitButton();
        this.showProgressBar();
        setTimeout(function () {
          _this2.hideProgressBar();

          _this2.insertSendSuccessMessage();

          setTimeout(function () {
            window.location.reload(true);
          }, 3000);
        }, 2000);
      }
    }
  }, {
    key: "isDifferent",
    value: function isDifferent(el, handler) {
      if (el.previousValue != el.value) {
        handler.call(this);
      }

      el.previousValue = el.value;
    }
  }, {
    key: "textAreaHandler",
    value: function textAreaHandler() {
      var _this3 = this;

      this.textArea.errors = false;
      this.textAreaImmediately();
      clearTimeout(this.textArea.timer);
      this.textArea.timer = setTimeout(function () {
        return _this3.textAreaAfterDelay();
      }, 800);
    }
  }, {
    key: "phoneHandler",
    value: function phoneHandler() {
      var _this4 = this;

      this.phone.errors = false;
      this.phoneImmediately();
      clearTimeout(this.phone.timer);
      this.phone.timer = setTimeout(function () {
        return _this4.phoneAfterDelay();
      }, 800);
    }
  }, {
    key: "firstNameHandler",
    value: function firstNameHandler() {
      var _this5 = this;

      this.firstName.errors = false;
      this.firstNameImmediately();
      clearTimeout(this.firstName.timer);
      this.firstName.timer = setTimeout(function () {
        return _this5.firstNameAfterDelay();
      }, 800);
    }
  }, {
    key: "lastNameHandler",
    value: function lastNameHandler() {
      var _this6 = this;

      this.lastName.errors = false;
      this.lastNameImmediately();
      clearTimeout(this.lastName.timer);
      this.lastName.timer = setTimeout(function () {
        return _this6.lastNameAfterDelay();
      }, 800);
    }
  }, {
    key: "emailHandler",
    value: function emailHandler() {
      var _this7 = this;

      this.email.errors = false;
      clearTimeout(this.email.timer);
      this.email.timer = setTimeout(function () {
        return _this7.emailAfterDelay();
      }, 800);
    }
  }, {
    key: "subjectHandler",
    value: function subjectHandler() {
      var _this8 = this;

      this.subject.errors = false;
      clearTimeout(this.subject.timer);
      this.subject.timer = setTimeout(function () {
        return _this8.subjectAfterDelay();
      }, 800);
    }
  }, {
    key: "emailAfterDelay",
    value: function emailAfterDelay() {
      if (!/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.email.value)) {
        this.showValidationError(this.email, "Ooops, du musst bitte eine gültige Email-Adresse angeben.");
        this.printRedLine(this.email);
      }

      if (!this.email.errors) {
        this.hideValidationError(this.email);
        this.printGreenLine(this.email);
      }
    }
  }, {
    key: "subjectAfterDelay",
    value: function subjectAfterDelay() {
      if (this.subject.value == "") {
        this.showValidationErrorColor(this.subject);
        this.subject.errors = true;
      }

      if (this.subject.value != "") {
        this.hideValidationErrorColor(this.subject);
        this.subject.errors = false;
      }
    }
  }, {
    key: "phoneImmediately",
    value: function phoneImmediately() {
      if (this.phone.value != "" && !/^[\d\s\-\+\(\)]+$/.test(this.phone.value)) {
        this.showValidationError(this.phone, "Ooops, entferne bitte alle Sonderzeichen und Buchstaben. ");
        this.printRedLine(this.phone);
      }

      if (this.phone.value.length > 30) {
        this.showValidationError(this.phone, "Ooops, Telefonnummer kann 30 Zeichen nicht übersteigen.");
        this.printRedLine(this.phone);
      }

      if (!this.phone.errors) {
        this.hideValidationError(this.phone);
        this.printGreenLine(this.phone);
      }
    }
  }, {
    key: "phoneAfterDelay",
    value: function phoneAfterDelay() {
      if (this.phone.value.length < 1) {
        this.showValidationError(this.phone, "Ooops, Telefonnummer muss mindestents ein Zeichen enthalten.");
        this.printRedLine(this.phone);
      }
    }
  }, {
    key: "firstNameImmediately",
    value: function firstNameImmediately() {
      if (this.firstName.value != "" && !/^([a-zA-Z0-9_\-\.\s\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF]+)$/.test(this.firstName.value)) {
        this.showValidationError(this.firstName, "Ooops, entferne bitte alle unzulässigen Soderzeichen.");
        this.printRedLine(this.firstName);
      }

      if (this.firstName.value.length > 30) {
        this.showValidationError(this.firstName, "Ooops, Vorname kann nicht 30 Zeichen übersteigen.");
        this.printRedLine(this.firstName);
      }

      if (!this.firstName.errors) {
        this.hideValidationError(this.firstName);
        this.printGreenLine(this.firstName);
      }
    }
  }, {
    key: "firstNameAfterDelay",
    value: function firstNameAfterDelay() {
      if (this.firstName.value.length < 1) {
        this.showValidationError(this.firstName, "Ooops, Vorname muss mindestents ein Zeichen enthalten.");
        this.printRedLine(this.firstName);
      }
    }
  }, {
    key: "textAreaImmediately",
    value: function textAreaImmediately() {
      if (this.textArea.value != "" && !/^([a-zA-Z0-9_\-\.\s\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF]+)$/.test(this.textArea.value)) {
        this.showValidationError(this.textArea, "Ooops, entferne bitte alle unzulässigen Soderzeichen.");
        this.printRedLine(this.textArea);
      }

      if (this.textArea.value.length > 2400) {
        this.showValidationError(this.textArea, "Ooops, Nachricht kann nicht 1200 Zeichen übersteigen.");
        this.printRedLine(this.textArea);
      }

      if (!this.textArea.errors) {
        this.hideValidationError(this.textArea);
        this.printGreenLine(this.textArea);
      }
    }
  }, {
    key: "textAreaAfterDelay",
    value: function textAreaAfterDelay() {
      if (this.textArea.value.length < 1) {
        this.showValidationError(this.textArea, "Ooops, Nachricht muss mindestents ein Zeichen enthalten.");
        this.printRedLine(this.textArea);
      }
    }
  }, {
    key: "lastNameImmediately",
    value: function lastNameImmediately() {
      if (this.lastName.value != "" && !/^([a-zA-Z0-9_\-\.\s\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF]+)$/.test(this.lastName.value)) {
        this.showValidationError(this.lastName, "Ooops, entferne bitte alle unzulässigen Soderzeichen.");
        this.printRedLine(this.lastName);
      }

      if (this.lastName.value.length > 30) {
        this.showValidationError(this.lastName, "Ooops, Nachname kann nicht 30 Zeichen übersteigen.");
        this.printRedLine(this.lastName);
      }

      if (!this.lastName.errors) {
        this.hideValidationError(this.lastName);
        this.printGreenLine(this.lastName);
      }
    }
  }, {
    key: "lastNameAfterDelay",
    value: function lastNameAfterDelay() {
      if (this.lastName.value.length < 1) {
        this.showValidationError(this.lastName, "Ooops, Nachname muss mindestents ein Zeichen enthalten.");
        this.printRedLine(this.lastName);
      }
    }
  }, {
    key: "hideValidationError",
    value: function hideValidationError(el) {
      el.nextElementSibling.classList.remove("liveValidateMessage--visible");
    }
  }, {
    key: "showValidationError",
    value: function showValidationError(el, message) {
      el.nextElementSibling.innerHTML = message;
      el.nextElementSibling.classList.add("liveValidateMessage--visible");
      el.errors = true;
    }
  }, {
    key: "showValidationErrorColor",
    value: function showValidationErrorColor() {
      this.helperText.style.color = "red";
    }
  }, {
    key: "hideValidationErrorColor",
    value: function hideValidationErrorColor() {
      this.helperText.style.color = "#64bc46";
    }
  }, {
    key: "printRedLine",
    value: function printRedLine(el) {
      el.style.borderBottomColor = "red";
    }
  }, {
    key: "printGreenLine",
    value: function printGreenLine(el) {
      el.style.borderBottomColor = "#64bc46";
    }
  }, {
    key: "checkConsens",
    value: function checkConsens() {
      if (!this.checkboxconsens.checked) {
        this.checkboxconsens.errors = true;
        return false;
      }

      this.checkboxconsens.errors = false;
      return true;
    }
  }, {
    key: "insertValidationElements",
    value: function insertValidationElements() {
      this.allFields.forEach(function (el) {
        el.insertAdjacentHTML('afterend', '<div class="alert alert-danger small liveValidateMessage"></div>');
      });
    }
  }, {
    key: "showProgressBar",
    value: function showProgressBar() {
      this.progressbar.style.display = 'block';
    }
  }, {
    key: "hideProgressBar",
    value: function hideProgressBar() {
      this.progressbar.style.display = 'none';
    }
  }, {
    key: "hideSubmitButton",
    value: function hideSubmitButton() {
      this.btnKontaktform.style.display = 'none';
    }
  }, {
    key: "honeypotValue",
    value: function honeypotValue() {
      this.honeypot.errors = false;

      if (this.honeypot.value.length != 0) {
        this.honeypot.errors = true;
      }
    }
  }, {
    key: "insertSendSuccessMessage",
    value: function insertSendSuccessMessage() {
      this.form.insertAdjacentHTML('beforeend', "\n    <div class=\"card-panel\">\n      <span class=\"white-text\">\n       <p>Nachricht erfolgreich abgeschickt. Vielen Dank! </p>\n      </span>\n    </div>\n    ");
    }
  }]);

  return ContactForm;
}();

exports["default"] = ContactForm;

},{"./ConfigDatabase":3}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cookiebotGmap = cookiebotGmap;

var _Googlemaps = require("./Googlemaps");

function cookiebotGmap() {
  // Coockie Settings
  function setCookie(name, value, days) {
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      var expires = "; expires=" + date.toGMTString();
    } else var expires = "";

    document.cookie = name + "=" + value + expires + "; path=/";
  }

  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");

    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];

      while (c.charAt(0) == " ") {
        c = c.substring(1, c.length);
      }

      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }

    return null;
  }

  function eraseCookie(name) {
    setCookie(name, "", -1);
  }

  function ConsetGoogleMapsCoockie() {
    setCookie("ppw@gmaps_kWYMs963AXRdv9iHqt8Pa6FG", true, 1);
  }

  window.addEventListener('CookiebotOnAccept', function (e) {
    if (Cookiebot.consent.preferences) {
      ConsetGoogleMapsCoockie();
      var gmapelm = document.getElementById("googlemap");
      var script = document.createElement("script");
      script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyBSj9U7Nn8RPS5B3atzicPIVE9ORNg98SU&callback=initMap";
      script.setAttribute("async", "");
      script.setAttribute("defer", "");

      if (typeof gmapelm !== "undefined" && gmapelm !== null) {
        document.head.appendChild(script);
      } else {
        return null;
      }
    }
  }, false);
}

},{"./Googlemaps":6}],6:[function(require,module,exports){
"use strict";

window.initMap = function () {
  // Map positions
  var position = [52.278463, 8.069281];
  var centerPosition = [52.279246, 8.068316];
  var latLng = new google.maps.LatLng(position[0], position[1]);
  var centerLatLng = new google.maps.LatLng(centerPosition[0], centerPosition[1]); // Map options

  var options = {
    zoom: 17,
    streetViewControl: false,
    scaleControl: true,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    center: centerLatLng
  }; // Create map

  var map = new google.maps.Map(document.getElementById("googlemap"), options); // Create Polygon

  var polygonCoords = [{
    lat: 52.280164,
    lng: 8.067829
  }, {
    lat: 52.280061,
    lng: 8.068207
  }, {
    lat: 52.280325,
    lng: 8.068408
  }, {
    lat: 52.280429,
    lng: 8.068035
  }];
  var polygon = new google.maps.Polygon({
    paths: polygonCoords,
    strokeColor: "#FF0000",
    strokeOpacity: 0.8,
    strokeWeight: 3,
    fillColor: "#FF0000",
    fillOpacity: 0.35
  });
  polygon.setMap(map); // Create Polyline

  var flightPlanCoordinates = [{
    lat: 52.278463,
    lng: 8.069281
  }, {
    lat: 52.277988,
    lng: 8.068621
  }, {
    lat: 52.278493,
    lng: 8.068296
  }, {
    lat: 52.27972,
    lng: 8.069262
  }, {
    lat: 52.280038,
    lng: 8.068286
  }];
  var flightPath = new google.maps.Polyline({
    path: flightPlanCoordinates,
    geodesic: true,
    strokeColor: "#FF0000",
    strokeOpacity: 1.0,
    strokeWeight: 2
  });
  flightPath.setMap(map); // Show Marker

  var marker = new google.maps.Marker({
    position: latLng,
    map: map,
    draggable: false,
    animation: google.maps.Animation.DROP
  }); // Show content on Click

  var contentString = '<div id="content">' + '<div id="siteNotice">' + "</div>" + '<div id="bodyContent">' + "<p><b>Schinkelstraße 41</b> <br> <b>49074 Osnabrück</b></p>" + "</div>" + "</div>";
  var infoWindow = new google.maps.InfoWindow({
    content: contentString
  });
  marker.addListener("click", function () {
    infoWindow.open(map, marker);
  });
};

},{}],7:[function(require,module,exports){
(function(window, factory) {
	var lazySizes = factory(window, window.document, Date);
	window.lazySizes = lazySizes;
	if(typeof module == 'object' && module.exports){
		module.exports = lazySizes;
	}
}(typeof window != 'undefined' ?
      window : {}, function l(window, document, Date) { // Pass in the windoe Date function also for SSR because the Date class can be lost
	'use strict';
	/*jshint eqnull:true */

	var lazysizes, lazySizesCfg;

	(function(){
		var prop;

		var lazySizesDefaults = {
			lazyClass: 'lazyload',
			loadedClass: 'lazyloaded',
			loadingClass: 'lazyloading',
			preloadClass: 'lazypreload',
			errorClass: 'lazyerror',
			//strictClass: 'lazystrict',
			autosizesClass: 'lazyautosizes',
			srcAttr: 'data-src',
			srcsetAttr: 'data-srcset',
			sizesAttr: 'data-sizes',
			//preloadAfterLoad: false,
			minSize: 40,
			customMedia: {},
			init: true,
			expFactor: 1.5,
			hFac: 0.8,
			loadMode: 2,
			loadHidden: true,
			ricTimeout: 0,
			throttleDelay: 125,
		};

		lazySizesCfg = window.lazySizesConfig || window.lazysizesConfig || {};

		for(prop in lazySizesDefaults){
			if(!(prop in lazySizesCfg)){
				lazySizesCfg[prop] = lazySizesDefaults[prop];
			}
		}
	})();

	if (!document || !document.getElementsByClassName) {
		return {
			init: function () {},
			cfg: lazySizesCfg,
			noSupport: true,
		};
	}

	var docElem = document.documentElement;

	var supportPicture = window.HTMLPictureElement;

	var _addEventListener = 'addEventListener';

	var _getAttribute = 'getAttribute';

	/**
	 * Update to bind to window because 'this' becomes null during SSR
	 * builds.
	 */
	var addEventListener = window[_addEventListener].bind(window);

	var setTimeout = window.setTimeout;

	var requestAnimationFrame = window.requestAnimationFrame || setTimeout;

	var requestIdleCallback = window.requestIdleCallback;

	var regPicture = /^picture$/i;

	var loadEvents = ['load', 'error', 'lazyincluded', '_lazyloaded'];

	var regClassCache = {};

	var forEach = Array.prototype.forEach;

	var hasClass = function(ele, cls) {
		if(!regClassCache[cls]){
			regClassCache[cls] = new RegExp('(\\s|^)'+cls+'(\\s|$)');
		}
		return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
	};

	var addClass = function(ele, cls) {
		if (!hasClass(ele, cls)){
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
		}
	};

	var removeClass = function(ele, cls) {
		var reg;
		if ((reg = hasClass(ele,cls))) {
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
		}
	};

	var addRemoveLoadEvents = function(dom, fn, add){
		var action = add ? _addEventListener : 'removeEventListener';
		if(add){
			addRemoveLoadEvents(dom, fn);
		}
		loadEvents.forEach(function(evt){
			dom[action](evt, fn);
		});
	};

	var triggerEvent = function(elem, name, detail, noBubbles, noCancelable){
		var event = document.createEvent('Event');

		if(!detail){
			detail = {};
		}

		detail.instance = lazysizes;

		event.initEvent(name, !noBubbles, !noCancelable);

		event.detail = detail;

		elem.dispatchEvent(event);
		return event;
	};

	var updatePolyfill = function (el, full){
		var polyfill;
		if( !supportPicture && ( polyfill = (window.picturefill || lazySizesCfg.pf) ) ){
			if(full && full.src && !el[_getAttribute]('srcset')){
				el.setAttribute('srcset', full.src);
			}
			polyfill({reevaluate: true, elements: [el]});
		} else if(full && full.src){
			el.src = full.src;
		}
	};

	var getCSS = function (elem, style){
		return (getComputedStyle(elem, null) || {})[style];
	};

	var getWidth = function(elem, parent, width){
		width = width || elem.offsetWidth;

		while(width < lazySizesCfg.minSize && parent && !elem._lazysizesWidth){
			width =  parent.offsetWidth;
			parent = parent.parentNode;
		}

		return width;
	};

	var rAF = (function(){
		var running, waiting;
		var firstFns = [];
		var secondFns = [];
		var fns = firstFns;

		var run = function(){
			var runFns = fns;

			fns = firstFns.length ? secondFns : firstFns;

			running = true;
			waiting = false;

			while(runFns.length){
				runFns.shift()();
			}

			running = false;
		};

		var rafBatch = function(fn, queue){
			if(running && !queue){
				fn.apply(this, arguments);
			} else {
				fns.push(fn);

				if(!waiting){
					waiting = true;
					(document.hidden ? setTimeout : requestAnimationFrame)(run);
				}
			}
		};

		rafBatch._lsFlush = run;

		return rafBatch;
	})();

	var rAFIt = function(fn, simple){
		return simple ?
			function() {
				rAF(fn);
			} :
			function(){
				var that = this;
				var args = arguments;
				rAF(function(){
					fn.apply(that, args);
				});
			}
		;
	};

	var throttle = function(fn){
		var running;
		var lastTime = 0;
		var gDelay = lazySizesCfg.throttleDelay;
		var rICTimeout = lazySizesCfg.ricTimeout;
		var run = function(){
			running = false;
			lastTime = Date.now();
			fn();
		};
		var idleCallback = requestIdleCallback && rICTimeout > 49 ?
			function(){
				requestIdleCallback(run, {timeout: rICTimeout});

				if(rICTimeout !== lazySizesCfg.ricTimeout){
					rICTimeout = lazySizesCfg.ricTimeout;
				}
			} :
			rAFIt(function(){
				setTimeout(run);
			}, true)
		;

		return function(isPriority){
			var delay;

			if((isPriority = isPriority === true)){
				rICTimeout = 33;
			}

			if(running){
				return;
			}

			running =  true;

			delay = gDelay - (Date.now() - lastTime);

			if(delay < 0){
				delay = 0;
			}

			if(isPriority || delay < 9){
				idleCallback();
			} else {
				setTimeout(idleCallback, delay);
			}
		};
	};

	//based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
	var debounce = function(func) {
		var timeout, timestamp;
		var wait = 99;
		var run = function(){
			timeout = null;
			func();
		};
		var later = function() {
			var last = Date.now() - timestamp;

			if (last < wait) {
				setTimeout(later, wait - last);
			} else {
				(requestIdleCallback || run)(run);
			}
		};

		return function() {
			timestamp = Date.now();

			if (!timeout) {
				timeout = setTimeout(later, wait);
			}
		};
	};

	var loader = (function(){
		var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;

		var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;

		var regImg = /^img$/i;
		var regIframe = /^iframe$/i;

		var supportScroll = ('onscroll' in window) && !(/(gle|ing)bot/.test(navigator.userAgent));

		var shrinkExpand = 0;
		var currentExpand = 0;

		var isLoading = 0;
		var lowRuns = -1;

		var resetPreloading = function(e){
			isLoading--;
			if(!e || isLoading < 0 || !e.target){
				isLoading = 0;
			}
		};

		var isVisible = function (elem) {
			if (isBodyHidden == null) {
				isBodyHidden = getCSS(document.body, 'visibility') == 'hidden';
			}

			return isBodyHidden || !(getCSS(elem.parentNode, 'visibility') == 'hidden' && getCSS(elem, 'visibility') == 'hidden');
		};

		var isNestedVisible = function(elem, elemExpand){
			var outerRect;
			var parent = elem;
			var visible = isVisible(elem);

			eLtop -= elemExpand;
			eLbottom += elemExpand;
			eLleft -= elemExpand;
			eLright += elemExpand;

			while(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){
				visible = ((getCSS(parent, 'opacity') || 1) > 0);

				if(visible && getCSS(parent, 'overflow') != 'visible'){
					outerRect = parent.getBoundingClientRect();
					visible = eLright > outerRect.left &&
						eLleft < outerRect.right &&
						eLbottom > outerRect.top - 1 &&
						eLtop < outerRect.bottom + 1
					;
				}
			}

			return visible;
		};

		var checkElements = function() {
			var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal,
				beforeExpandVal, defaultExpand, preloadExpand, hFac;
			var lazyloadElems = lazysizes.elements;

			if((loadMode = lazySizesCfg.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)){

				i = 0;

				lowRuns++;

				for(; i < eLlen; i++){

					if(!lazyloadElems[i] || lazyloadElems[i]._lazyRace){continue;}

					if(!supportScroll || (lazysizes.prematureUnveil && lazysizes.prematureUnveil(lazyloadElems[i]))){unveilElement(lazyloadElems[i]);continue;}

					if(!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)){
						elemExpand = currentExpand;
					}

					if (!defaultExpand) {
						defaultExpand = (!lazySizesCfg.expand || lazySizesCfg.expand < 1) ?
							docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 :
							lazySizesCfg.expand;

						lazysizes._defEx = defaultExpand;

						preloadExpand = defaultExpand * lazySizesCfg.expFactor;
						hFac = lazySizesCfg.hFac;
						isBodyHidden = null;

						if(currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden){
							currentExpand = preloadExpand;
							lowRuns = 0;
						} else if(loadMode > 1 && lowRuns > 1 && isLoading < 6){
							currentExpand = defaultExpand;
						} else {
							currentExpand = shrinkExpand;
						}
					}

					if(beforeExpandVal !== elemExpand){
						eLvW = innerWidth + (elemExpand * hFac);
						elvH = innerHeight + elemExpand;
						elemNegativeExpand = elemExpand * -1;
						beforeExpandVal = elemExpand;
					}

					rect = lazyloadElems[i].getBoundingClientRect();

					if ((eLbottom = rect.bottom) >= elemNegativeExpand &&
						(eLtop = rect.top) <= elvH &&
						(eLright = rect.right) >= elemNegativeExpand * hFac &&
						(eLleft = rect.left) <= eLvW &&
						(eLbottom || eLright || eLleft || eLtop) &&
						(lazySizesCfg.loadHidden || isVisible(lazyloadElems[i])) &&
						((isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4)) || isNestedVisible(lazyloadElems[i], elemExpand))){
						unveilElement(lazyloadElems[i]);
						loadedSomething = true;
						if(isLoading > 9){break;}
					} else if(!loadedSomething && isCompleted && !autoLoadElem &&
						isLoading < 4 && lowRuns < 4 && loadMode > 2 &&
						(preloadElems[0] || lazySizesCfg.preloadAfterLoad) &&
						(preloadElems[0] || (!elemExpandVal && ((eLbottom || eLright || eLleft || eLtop) || lazyloadElems[i][_getAttribute](lazySizesCfg.sizesAttr) != 'auto')))){
						autoLoadElem = preloadElems[0] || lazyloadElems[i];
					}
				}

				if(autoLoadElem && !loadedSomething){
					unveilElement(autoLoadElem);
				}
			}
		};

		var throttledCheckElements = throttle(checkElements);

		var switchLoadingClass = function(e){
			var elem = e.target;

			if (elem._lazyCache) {
				delete elem._lazyCache;
				return;
			}

			resetPreloading(e);
			addClass(elem, lazySizesCfg.loadedClass);
			removeClass(elem, lazySizesCfg.loadingClass);
			addRemoveLoadEvents(elem, rafSwitchLoadingClass);
			triggerEvent(elem, 'lazyloaded');
		};
		var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
		var rafSwitchLoadingClass = function(e){
			rafedSwitchLoadingClass({target: e.target});
		};

		var changeIframeSrc = function(elem, src){
			try {
				elem.contentWindow.location.replace(src);
			} catch(e){
				elem.src = src;
			}
		};

		var handleSources = function(source){
			var customMedia;

			var sourceSrcset = source[_getAttribute](lazySizesCfg.srcsetAttr);

			if( (customMedia = lazySizesCfg.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) ){
				source.setAttribute('media', customMedia);
			}

			if(sourceSrcset){
				source.setAttribute('srcset', sourceSrcset);
			}
		};

		var lazyUnveil = rAFIt(function (elem, detail, isAuto, sizes, isImg){
			var src, srcset, parent, isPicture, event, firesLoad;

			if(!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented){

				if(sizes){
					if(isAuto){
						addClass(elem, lazySizesCfg.autosizesClass);
					} else {
						elem.setAttribute('sizes', sizes);
					}
				}

				srcset = elem[_getAttribute](lazySizesCfg.srcsetAttr);
				src = elem[_getAttribute](lazySizesCfg.srcAttr);

				if(isImg) {
					parent = elem.parentNode;
					isPicture = parent && regPicture.test(parent.nodeName || '');
				}

				firesLoad = detail.firesLoad || (('src' in elem) && (srcset || src || isPicture));

				event = {target: elem};

				addClass(elem, lazySizesCfg.loadingClass);

				if(firesLoad){
					clearTimeout(resetPreloadingTimer);
					resetPreloadingTimer = setTimeout(resetPreloading, 2500);
					addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
				}

				if(isPicture){
					forEach.call(parent.getElementsByTagName('source'), handleSources);
				}

				if(srcset){
					elem.setAttribute('srcset', srcset);
				} else if(src && !isPicture){
					if(regIframe.test(elem.nodeName)){
						changeIframeSrc(elem, src);
					} else {
						elem.src = src;
					}
				}

				if(isImg && (srcset || isPicture)){
					updatePolyfill(elem, {src: src});
				}
			}

			if(elem._lazyRace){
				delete elem._lazyRace;
			}
			removeClass(elem, lazySizesCfg.lazyClass);

			rAF(function(){
				// Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
				var isLoaded = elem.complete && elem.naturalWidth > 1;

				if( !firesLoad || isLoaded){
					if (isLoaded) {
						addClass(elem, 'ls-is-cached');
					}
					switchLoadingClass(event);
					elem._lazyCache = true;
					setTimeout(function(){
						if ('_lazyCache' in elem) {
							delete elem._lazyCache;
						}
					}, 9);
				}
				if (elem.loading == 'lazy') {
					isLoading--;
				}
			}, true);
		});

		var unveilElement = function (elem){
			if (elem._lazyRace) {return;}
			var detail;

			var isImg = regImg.test(elem.nodeName);

			//allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
			var sizes = isImg && (elem[_getAttribute](lazySizesCfg.sizesAttr) || elem[_getAttribute]('sizes'));
			var isAuto = sizes == 'auto';

			if( (isAuto || !isCompleted) && isImg && (elem[_getAttribute]('src') || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesCfg.errorClass) && hasClass(elem, lazySizesCfg.lazyClass)){return;}

			detail = triggerEvent(elem, 'lazyunveilread').detail;

			if(isAuto){
				 autoSizer.updateElem(elem, true, elem.offsetWidth);
			}

			elem._lazyRace = true;
			isLoading++;

			lazyUnveil(elem, detail, isAuto, sizes, isImg);
		};

		var afterScroll = debounce(function(){
			lazySizesCfg.loadMode = 3;
			throttledCheckElements();
		});

		var altLoadmodeScrollListner = function(){
			if(lazySizesCfg.loadMode == 3){
				lazySizesCfg.loadMode = 2;
			}
			afterScroll();
		};

		var onload = function(){
			if(isCompleted){return;}
			if(Date.now() - started < 999){
				setTimeout(onload, 999);
				return;
			}


			isCompleted = true;

			lazySizesCfg.loadMode = 3;

			throttledCheckElements();

			addEventListener('scroll', altLoadmodeScrollListner, true);
		};

		return {
			_: function(){
				started = Date.now();

				lazysizes.elements = document.getElementsByClassName(lazySizesCfg.lazyClass);
				preloadElems = document.getElementsByClassName(lazySizesCfg.lazyClass + ' ' + lazySizesCfg.preloadClass);

				addEventListener('scroll', throttledCheckElements, true);

				addEventListener('resize', throttledCheckElements, true);

				addEventListener('pageshow', function (e) {
					if (e.persisted) {
						var loadingElements = document.querySelectorAll('.' + lazySizesCfg.loadingClass);

						if (loadingElements.length && loadingElements.forEach) {
							requestAnimationFrame(function () {
								loadingElements.forEach( function (img) {
									if (img.complete) {
										unveilElement(img);
									}
								});
							});
						}
					}
				});

				if(window.MutationObserver){
					new MutationObserver( throttledCheckElements ).observe( docElem, {childList: true, subtree: true, attributes: true} );
				} else {
					docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
					docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
					setInterval(throttledCheckElements, 999);
				}

				addEventListener('hashchange', throttledCheckElements, true);

				//, 'fullscreenchange'
				['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend'].forEach(function(name){
					document[_addEventListener](name, throttledCheckElements, true);
				});

				if((/d$|^c/.test(document.readyState))){
					onload();
				} else {
					addEventListener('load', onload);
					document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
					setTimeout(onload, 20000);
				}

				if(lazysizes.elements.length){
					checkElements();
					rAF._lsFlush();
				} else {
					throttledCheckElements();
				}
			},
			checkElems: throttledCheckElements,
			unveil: unveilElement,
			_aLSL: altLoadmodeScrollListner,
		};
	})();


	var autoSizer = (function(){
		var autosizesElems;

		var sizeElement = rAFIt(function(elem, parent, event, width){
			var sources, i, len;
			elem._lazysizesWidth = width;
			width += 'px';

			elem.setAttribute('sizes', width);

			if(regPicture.test(parent.nodeName || '')){
				sources = parent.getElementsByTagName('source');
				for(i = 0, len = sources.length; i < len; i++){
					sources[i].setAttribute('sizes', width);
				}
			}

			if(!event.detail.dataAttr){
				updatePolyfill(elem, event.detail);
			}
		});
		var getSizeElement = function (elem, dataAttr, width){
			var event;
			var parent = elem.parentNode;

			if(parent){
				width = getWidth(elem, parent, width);
				event = triggerEvent(elem, 'lazybeforesizes', {width: width, dataAttr: !!dataAttr});

				if(!event.defaultPrevented){
					width = event.detail.width;

					if(width && width !== elem._lazysizesWidth){
						sizeElement(elem, parent, event, width);
					}
				}
			}
		};

		var updateElementsSizes = function(){
			var i;
			var len = autosizesElems.length;
			if(len){
				i = 0;

				for(; i < len; i++){
					getSizeElement(autosizesElems[i]);
				}
			}
		};

		var debouncedUpdateElementsSizes = debounce(updateElementsSizes);

		return {
			_: function(){
				autosizesElems = document.getElementsByClassName(lazySizesCfg.autosizesClass);
				addEventListener('resize', debouncedUpdateElementsSizes);
			},
			checkElems: debouncedUpdateElementsSizes,
			updateElem: getSizeElement
		};
	})();

	var init = function(){
		if(!init.i && document.getElementsByClassName){
			init.i = true;
			autoSizer._();
			loader._();
		}
	};

	setTimeout(function(){
		if(lazySizesCfg.init){
			init();
		}
	});

	lazysizes = {
		cfg: lazySizesCfg,
		autoSizer: autoSizer,
		loader: loader,
		init: init,
		uP: updatePolyfill,
		aC: addClass,
		rC: removeClass,
		hC: hasClass,
		fire: triggerEvent,
		gW: getWidth,
		rAF: rAF,
	};

	return lazysizes;
}
));

},{}],8:[function(require,module,exports){
/*! lazysizes - v5.2.0 */
!function(a,b){var c=function(){b(a.lazySizes),a.removeEventListener("lazyunveilread",c,!0)};b=b.bind(null,a,a.document),"object"==typeof module&&module.exports?b(require("lazysizes")):a.lazySizes?c():a.addEventListener("lazyunveilread",c,!0)}(window,function(a,b,c){"use strict";if(a.addEventListener){var d=c.cfg,e=/\s+/g,f=/\s*\|\s+|\s+\|\s*/g,g=/^(.+?)(?:\s+\[\s*(.+?)\s*\])(?:\s+\[\s*(.+?)\s*\])?$/,h=/^\s*\(*\s*type\s*:\s*(.+?)\s*\)*\s*$/,i=/\(|\)|'/,j={contain:1,cover:1},k=function(a){var b=c.gW(a,a.parentNode);return(!a._lazysizesWidth||b>a._lazysizesWidth)&&(a._lazysizesWidth=b),a._lazysizesWidth},l=function(a){var b;return b=(getComputedStyle(a)||{getPropertyValue:function(){}}).getPropertyValue("background-size"),!j[b]&&j[a.style.backgroundSize]&&(b=a.style.backgroundSize),b},m=function(a,b){if(b){var c=b.match(h);c&&c[1]?a.setAttribute("type",c[1]):a.setAttribute("media",d.customMedia[b]||b)}},n=function(a,c,h){var i=b.createElement("picture"),j=c.getAttribute(d.sizesAttr),k=c.getAttribute("data-ratio"),l=c.getAttribute("data-optimumx");c._lazybgset&&c._lazybgset.parentNode==c&&c.removeChild(c._lazybgset),Object.defineProperty(h,"_lazybgset",{value:c,writable:!0}),Object.defineProperty(c,"_lazybgset",{value:i,writable:!0}),a=a.replace(e," ").split(f),i.style.display="none",h.className=d.lazyClass,1!=a.length||j||(j="auto"),a.forEach(function(a){var c,e=b.createElement("source");j&&"auto"!=j&&e.setAttribute("sizes",j),(c=a.match(g))?(e.setAttribute(d.srcsetAttr,c[1]),m(e,c[2]),m(e,c[3])):e.setAttribute(d.srcsetAttr,a),i.appendChild(e)}),j&&(h.setAttribute(d.sizesAttr,j),c.removeAttribute(d.sizesAttr),c.removeAttribute("sizes")),l&&h.setAttribute("data-optimumx",l),k&&h.setAttribute("data-ratio",k),i.appendChild(h),c.appendChild(i)},o=function(a){if(a.target._lazybgset){var b=a.target,d=b._lazybgset,e=b.currentSrc||b.src;if(e){var f=c.fire(d,"bgsetproxy",{src:e,useSrc:i.test(e)?JSON.stringify(e):e});f.defaultPrevented||(d.style.backgroundImage="url("+f.detail.useSrc+")")}b._lazybgsetLoading&&(c.fire(d,"_lazyloaded",{},!1,!0),delete b._lazybgsetLoading)}};addEventListener("lazybeforeunveil",function(a){var d,e,f;!a.defaultPrevented&&(d=a.target.getAttribute("data-bgset"))&&(f=a.target,e=b.createElement("img"),e.alt="",e._lazybgsetLoading=!0,a.detail.firesLoad=!0,n(d,f,e),setTimeout(function(){c.loader.unveil(e),c.rAF(function(){c.fire(e,"_lazyloaded",{},!0,!0),e.complete&&o({target:e})})}))}),b.addEventListener("load",o,!0),a.addEventListener("lazybeforesizes",function(a){if(a.detail.instance==c&&a.target._lazybgset&&a.detail.dataAttr){var b=a.target._lazybgset,d=l(b);j[d]&&(a.target._lazysizesParentFit=d,c.rAF(function(){a.target.setAttribute("data-parent-fit",d),a.target._lazysizesParentFit&&delete a.target._lazysizesParentFit}))}},!0),b.documentElement.addEventListener("lazybeforesizes",function(a){!a.defaultPrevented&&a.target._lazybgset&&a.detail.instance==c&&(a.detail.width=k(a.target._lazybgset))})}});
},{"lazysizes":7}],9:[function(require,module,exports){
/*! lazysizes - v5.2.0 */
!function(a,b){var c=function(){b(a.lazySizes),a.removeEventListener("lazyunveilread",c,!0)};b=b.bind(null,a,a.document),"object"==typeof module&&module.exports?b(require("lazysizes")):a.lazySizes?c():a.addEventListener("lazyunveilread",c,!0)}(window,function(a,b,c){"use strict";function d(a,c){if(!g[a]){var d=b.createElement(c?"link":"script"),e=b.getElementsByTagName("script")[0];c?(d.rel="stylesheet",d.href=a):d.src=a,g[a]=!0,g[d.src||d.href]=!0,e.parentNode.insertBefore(d,e)}}var e,f,g={};b.addEventListener&&(f=/\(|\)|\s|'/,e=function(a,c){var d=b.createElement("img");d.onload=function(){d.onload=null,d.onerror=null,d=null,c()},d.onerror=d.onload,d.src=a,d&&d.complete&&d.onload&&d.onload()},addEventListener("lazybeforeunveil",function(a){if(a.detail.instance==c){var b,g,h,i;if(!a.defaultPrevented){var j=a.target;if("none"==j.preload&&(j.preload=j.getAttribute("data-preload")||"auto"),null!=j.getAttribute("data-autoplay"))if(j.getAttribute("data-expand")&&!j.autoplay)try{j.play()}catch(a){}else requestAnimationFrame(function(){j.setAttribute("data-expand","-10"),c.aC(j,c.cfg.lazyClass)});b=j.getAttribute("data-link"),b&&d(b,!0),b=j.getAttribute("data-script"),b&&d(b),b=j.getAttribute("data-require"),b&&(c.cfg.requireJs?c.cfg.requireJs([b]):d(b)),h=j.getAttribute("data-bg"),h&&(a.detail.firesLoad=!0,g=function(){j.style.backgroundImage="url("+(f.test(h)?JSON.stringify(h):h)+")",a.detail.firesLoad=!1,c.fire(j,"_lazyloaded",{},!0,!0)},e(h,g)),i=j.getAttribute("data-poster"),i&&(a.detail.firesLoad=!0,g=function(){j.poster=i,a.detail.firesLoad=!1,c.fire(j,"_lazyloaded",{},!0,!0)},e(i,g))}}},!1))});
},{"lazysizes":7}]},{},[1]);
